import React, { useEffect, useState } from 'react'
import { Tooltip } from 'src/component/Tooltip';
import { useOrderStore } from 'src/hooks/order';
import useReduxState from 'src/hooks/useReduxState';
import System from 'src/helper/system';
import AxiosIndicatorRunTimeLoader from 'src/component/AxiosIndicatorRunTimeLoader';
import { useFilterSelectionStore } from 'src/hooks/component/filter_selection';
import Constants from 'src/support/Constants';
import SystemAlerts from 'src/component/SystemAlerts';
import Helper from 'src/support/Helper';
import Modal from 'src/component/Global/Modal';
import ScheduleOrderReport from '../OrderReport/ScheduleOrderReport';
import ManageOrderReport from '../OrderReport/ManageOrderReport';


const OrderHistoryHeader = (props) => {
    const [{ order_list, order_export_count }, { }, { export_order }] = useOrderStore();
    const [isExportFilter, setIsExportFilter] = useReduxState(false, 'setIsExportFilter');
    const [pageLoader, setPageLoader] = useState(false);
    const [{ filter_list }, { }, { }] = useFilterSelectionStore();
    const [disable, setDisable] = useState({ emailFiltered: false });
    const [showScheduleModal, setShowScheduleModal] = useState(false);
    const [scheduleModalContent, setScheduleModalContent] = useState('');
    const [enableModalClosing, setEnableModalClosing] = useState(true);
    const [isCoreUser, setIsCoreUser] = useState(false);
    const { siteUser } = Constants;

    const orderReportsConstants = {
        statusOptions: [
            { key: 'All', slug: 'All Orders' },
            { key: 'Order_Placed', slug: 'Order Pending' },
            { key: 'In_process', slug: 'In Process' },
            { key: 'Canceled', slug: 'Cancelled' },
            { key: 'Shipped', slug: 'Shipped' },
            { key: 'Partially_Shipped', slug: 'Partially Shipped' },
            { key: 'Invoiced', slug: 'Invoiced' }
        ],
        includeOrdersFromOptions: [
            { key: 7, slug: 'Last 7 days' },
            { key: 30, slug: 'Last 30 days' },
            { key: 90, slug: 'Last 90 days' },
            { key: 180, slug: 'Last 6 months' },
            { key: 365, slug: 'Last 12 months' },
        ],
        reportFrequencyOptions: [
            { key: 7, slug: 'Every 7 days' },
            { key: 14, slug: 'Every 14 days' },
            { key: 30, slug: 'Every 30 days' },
            { key: 90, slug: 'Every 90 days' }
        ]
    }

    const closeModal = () => {
        setShowScheduleModal(false);
        setScheduleModalContent('');
        setEnableModalClosing(true);
    }

    useEffect(() => {
        sessionStorage.removeItem("successUrl");
        setIsCoreUser(System.avUserInfoData.userType === siteUser.CORE);
    }, []);

    useEffect(() => {
        const isOrderListEmpty = order_list && order_list.total === 0;
        if (isOrderListEmpty) {
            if (order_export_count > 0) {
                setDisable({ emailFiltered: true, emailAll: false })
            } else {
                setDisable({ emailFiltered: true, emailAll: true })
            }
        }
        else if (!isOrderListEmpty) {
            setDisable({ emailFiltered: false, emailAll: false })
        }
    }, [order_list, filter_list, order_export_count]);

    const exportAllOrder = async () => {
        closeDropdown();
        setPageLoader(true);
        setTimeout(() => {
            setPageLoader(false);
            System.popup('ThankYouPopup', { isOrderHistory: true });
        }, 2000);
        let result = await export_order({
            "keyword": "",
            "searchType": "",
            "filterByOption": [],
            "timeSpan": "",
            "sortBy": "",
            "sortOrder": "",
            "isExportAll": true,
            "isEmail": true
        });
    }

    const exportFilterOrder = async () => {
        closeDropdown();
        setPageLoader(true);
        await setIsExportFilter(true);
        setTimeout(() => {
            setPageLoader(false);
        }, 2000);
    }

    const closeDropdown = () => {
        let _dropdownElem = document.getElementById('orderOptionsFilter');
        if (_dropdownElem !== undefined && _dropdownElem.classList.contains('open')) {
            _dropdownElem.classList.remove('open');
        }
    }

    return (
        <>
            <div className="pcn-page-head header-container d-flex align-items-center justify-sm-content-between flex-wrap flex-sm-nowrap">
                <div className="page-title font-oswald font-light font-30 mb-3 mb-sm-0">Order Details</div>
                <div className="ms-sm-auto mb-0">
                    <ul className="d-flex justify-content-start justify-content-lg-end list-unstyled mb-0 order-history-top">
                        <span className='order-history-header'>
                            <div className="ms-4">
                                {pageLoader && <AxiosIndicatorRunTimeLoader />}
                            </div>
                            {pageLoader === false &&
                                <div className='primary-caret ms-4'>
                                <div className="dropdown selectbox order-dropdown show" id="orderOptionsFilter">
                                    <a className="bs5 form-control form-control-sm text-black dropdown-control w180 my-cart-address-select dropdown-toggle" href={void(0)} role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <span>Order Options</span>
                                    </a>
                                    <ul className="dropdown-menu minw180" aria-labelledby="dropdownMenuButton1">
                                        <li>
                                            <Tooltip
                                                position={'left center'}
                                                opener={() => (
                                                    <a className="dropdown-item" href={void (0)}>Key/Legend</a>
                                                )}
                                                content={() => (
                                                    <>
                                                        <b>Offline:</b> Orders created in the {System.avUserInfoData.speedBoatName} <br />
                                                        Internal Order Tool <br />
                                                        <b>Online:</b> Orders created in {Helper.getHCLDXBaseUrlHost()}
                                                    </>
                                                )}
                                            />
                                        </li>
                                        <li><a className={disable.emailAll ? "dropdown-item link-disabled" : "dropdown-item"} href={void (0)}
                                            onClick={() => exportAllOrder()}>Email All</a></li>
                                        <li><a className={disable.emailFiltered ? "dropdown-item link-disabled" : "dropdown-item"} href={void (0)}
                                            onClick={() => exportFilterOrder()}>Email Filtered</a></li>
                                        <li>
                                            <Tooltip
                                                position={'left center'}
                                                opener={() => (
                                                    <a className="dropdown-item" href={void (0)}>Information</a>
                                                )}
                                                content={() => (
                                                    <>
                                                        Additional order information available by choosing to receive an email on your orders.
                                                    </>
                                                )}
                                            />
                                        </li>
                                        {isCoreUser && (
                                            <>
                                                <li><a className="dropdown-item" href={void (0)}
                                                    onClick={() => { setShowScheduleModal(true); setScheduleModalContent('schedule-order-report'); }}>Schedule Order Report</a></li>
                                                <li><a className="dropdown-item" href={void (0)}
                                                    onClick={() => { setShowScheduleModal(true); setScheduleModalContent('manage-order-reports'); }}>Manage Order Reports</a></li>
                                            </>
                                        )}
                                    </ul>
                                </div>
                                </div>
                            }
                        </span>
                    </ul>
                </div>
            </div>
            <div className="pcn-line-divider mb-0" />
            <SystemAlerts />

            <Modal
                show={showScheduleModal}
                onHide={() => { if (enableModalClosing) closeModal(); }}
            >
                <div className="avnet-modal modal-680" id="roleSelection">
                    <div className='avnet-modal-inner'>
                        { scheduleModalContent === 'schedule-order-report'
                            && <ScheduleOrderReport
                                    setEnableModalClosing={setEnableModalClosing}
                                    closeModal={closeModal}
                                    enableModalClosing={enableModalClosing}
                                    statusOptions={orderReportsConstants.statusOptions}
                                    includeOrdersFromOptions={orderReportsConstants.includeOrdersFromOptions}
                                    reportFrequencyOptions={orderReportsConstants.reportFrequencyOptions}
                                /> }

                        { scheduleModalContent === 'manage-order-reports'
                            && <ManageOrderReport
                                    closeModal={closeModal}
                                    statusOptions={orderReportsConstants.statusOptions}
                                    includeOrdersFromOptions={orderReportsConstants.includeOrdersFromOptions}
                                    reportFrequencyOptions={orderReportsConstants.reportFrequencyOptions}
                                /> }
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default OrderHistoryHeader
